<template>
  <div class="container" @click="maskClose">
    <div class="content-wrap">
      <div class="content">
        <img
          class="close"
          src="../../../../images/money_tree/dialog/close.png"
          @click="onClose"
        />
        <div class="records-wrap">
          <div v-if="!recordList || !recordList.length" class="no-data-wrap">
            <img
              class="img"
              src="../../../../images/money_tree/dialog/empty.png"
            />
            <span class="txt">暂无数据</span>
          </div>
          <ul v-else v-touch-fix>
            <li v-for="(item, index) in recordList" :key="index">
              <span class="txt date">{{ converDate(item.timestamp) }}</span>
              <span class="txt name">{{ item.prizeName }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  directives: {
    touchFix: {
      bind: function (el, binding, vnode) {
        el.addEventListener(
          'touchmove',
          e => {
            // 滚动容器阻止冒泡，因此是否prevent由当前函数决定
            e.stopPropagation()
            const scrollEl = e.currentTarget
            // 判定当前滚动容器是否可以滚动
            if (scrollEl.scrollHeight <= scrollEl.offsetHeight) {
              // 不能滚动的时候依然需要阻止滚动穿透
              e.preventDefault()
            }
          },
          false
        )
      }
    }
  },
  props: {
    recordList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    maskClose() {
      this.$emit('close')
    },

    converDate(timeStamp) {
      const date = new Date()
      date.setTime(timeStamp * 1000)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? '0' + d : d
      var h = date.getHours()
      h = h < 10 ? '0' + h : h
      var minute = date.getMinutes()
      // var second = date.getSeconds()
      minute = minute < 10 ? '0' + minute : minute
      // second = second < 10 ? '0' + second : second
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;

  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  overflow: hidden;

  flex-direction: column;
  justify-content: center;

  .content-wrap {
    display: flex;

    flex-direction: column;
    justify-content: center;
    align-items: center;

    .content {
      position: relative;

      width: 5.5rem;
      height: 6.6rem;
      overflow: hidden;

      background-image: url('../../../../images/money_tree/dialog/my_record_bg_2021.png');

      background-repeat: no-repeat;
      background-size: 100% 100%;

      .close {
        position: absolute;
        top: 0;
        right: 0;

        width: 0.79rem;
        height: 0.79rem;
      }

      .no-data-wrap {
        display: flex;

        position: absolute;
        right: 0.16rem;
        bottom: 0.16rem;
        left: 0.16rem;

        height: 223px;

        flex-direction: column;

        justify-content: center;
        align-items: center;

        .img {
          width: 2.18rem;
          height: 2.4rem;
          overflow: hidden;

          background-repeat: no-repeat;
          background-size: 100% 100%;
        }

        .txt {
          margin-top: 0.4rem;

          font-size: 0.26rem;
          text-align: center;
          color: #666666;
        }
      }

      .records-wrap {
        position: absolute;
        right: 0.16rem;
        bottom: 0.5rem;
        left: 0.16rem;

        height: 3.76rem; //223px;

        ul {
          width: 100%;
          height: 100%;
          overflow-y: auto;

          li {
            display: flex;

            margin-bottom: 0.4rem;
            padding: 0 0.4rem;

            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            .txt {
              font-size: 0.26rem;
              color: #333333;

              &.date {
                width: 112px;
                margin-right: 20px;

                text-align: left;
                word-break: break-all;
              }
              &.name {
                width: 0;

                flex: 1;

                text-align: center;
                word-break: break-all;
              }
            }
          }
        }
      }
    }
  }
}
</style>
